// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"881":"c3dea0b4","928":"8cbad42d"}[chunkId] + ".chunk.css";
};